import { useRouter } from 'next/router';

export const GIFT_CARDS_PAGE_TABS = { AMOUNTS: 'amounts', CARDS: 'cards', WALLETS: 'wallets' };
// Query keys this page owns; other keys on the URL (userId, businessAccountId) are kept as they are.
const PAGE_KEYS = ['tab', 'customerId', 'giftCardId'];

/**
 * Moves around the Gift cards page through its URL, so one section can open another: a gift card
 * opens its buyer's wallet, a wallet entry opens its gift card. Shallow, so nothing reloads.
 */
export const useGiftCardsPageLinks = () => {
  const router = useRouter();
  const { tab = null, customerId = null, giftCardId = null } = router.query;

  const go = (params) => {
    const kept = Object.fromEntries(Object.entries(router.query).filter(([key]) => !PAGE_KEYS.includes(key)));
    router.push({ pathname: router.pathname, query: { ...kept, ...params } }, undefined, { shallow: true });
  };

  return {
    tab,
    customerId,
    giftCardId,
    showTab: (key) => go({ tab: key }),
    openWallet: (id) => go({ tab: GIFT_CARDS_PAGE_TABS.WALLETS, customerId: id }),
    openGiftCard: (id) => go({ tab: GIFT_CARDS_PAGE_TABS.CARDS, giftCardId: id }),
  };
};
